export default "__VITE_ASSET__Fxx4PiV3__"